import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import InputText from '../InputText'
import MaskedInput from 'react-input-mask'

const InputPhoneNumber = ({
    onChange,
    value: val,
    label,
    name,
    error,
    variant = 'white',
    isRequired,
    className,
    disabled,
    ...otherProps
}) => {
    return (
        <div className="flex flex-col items-start justify-start w-full h-auto">
            {label && (
                <label
                    htmlFor={name}
                    className={clsx(
                        'w-full h-auto mb-2 text-sm font-semibold text-left',
                        variant === 'black'
                            ? 'text-white'
                            : 'text-textDarkerGray',
                    )}
                >
                    {label}
                    {isRequired && <span className="text-error ml-1">*</span>}
                </label>
            )}
            <div
                className={clsx(
                    'w-full flex flex-row items-start justify-center',
                )}
            >
                <p
                    className={clsx(
                        'h-12 border text-center border-r-0 w-16 rounded-tl-xl rounded-bl-xl font-medium text-sm flex items-center justify-center',
                        variant === 'white'
                            ? 'bg-grayBackground border-grayLines text-textDarkGray '
                            : 'bg-black60 border-black60 text-white ',
                        className,
                    )}
                >
                    +1
                </p>

                <MaskedInput
                    mask="(999) 999-9999"
                    autoComplete="tel"
                    maskChar=""
                    value={val ?? ''}
                    disabled={disabled}
                    onChange={e => onChange(e?.target?.value)}
                    className="disabled:bg-grayBackground"
                    name={name}
                    {...otherProps}
                >
                    {prop => (
                        <InputText
                            {...prop}
                            value={val ?? ''}
                            type="tel"
                            name={name}
                            key={null}
                            hasError={false}
                            variant={variant}
                            additionalInputClass={clsx(
                                'rounded-tl-none rounded-bl-none outline-none border-l-none',
                                className,
                            )}
                            label={null}
                            disabled={disabled}
                        />
                    )}
                </MaskedInput>
            </div>
            <p
                className={clsx(
                    error ? 'visible' : 'invisible',
                    'w-full h-4 text-right text-error font-medium text-xs mt-1',
                )}
            >
                {error}
            </p>
        </div>
    )
}

InputPhoneNumber.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    variant: PropTypes.string,
    isRequired: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
}

export default InputPhoneNumber
